import React from 'react';

import { VeraScoreChange } from './';
import { VeraScoreShieldIcon } from '../../atoms/icons';
import { colors } from '../../styles';

export interface Props {
  className?: string;
  change?: number;
  isLarge?: boolean;
  score: number;
  title: string;
}

class FleetVeraScore extends React.Component<Props, any> {
  public static defaultProps: Props = {
    isLarge: true,
    score: -1,
    title: '',
  };

  public render() {
    const { className, change, isLarge, score, title } = this.props;
    const isValidScore = !!(score && score > 0);
    const invalidScoreColorProp = isValidScore ? {} : { color: colors.grey700 };
    return (
      <div className={className}>
        <VeraScoreChange {...{ change, score, title }} isLarge={isLarge}>
          <VeraScoreShieldIcon
            {...{
              height: isLarge ? 56 : 42,
              ...invalidScoreColorProp,
            }}
          />
        </VeraScoreChange>
      </div>
    );
  }
}

export default FleetVeraScore;
